export enum PresentersRoutePath {
    Presenters = '/presenters',
    Detail = '/presenters/detail/:id',
    Create = '/presenters/create',
    Edit = '/presenters/edit/:id'
}
